export default __webpack_public_path__ + "static/media/user-08.c88e98a6.jpg";